module.exports = __webpack_public_path__ + "static/img/1.3a3b2ed6.png";